import { formatToDate, formatToDateTime } from 'helpers';
import { Typography } from 'libs/ui';

import { DocumentItemType } from '../types';

export const renderDate = (item: DocumentItemType) => (
  <Typography title={formatToDateTime(item.createdAt)} variant="caption">
    {formatToDate(item.createdAt)}
  </Typography>
);
